import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'antd';
import { FileListItem } from 'components/layout';
import isEmpty from 'utils/is-empty';
import './style.less';

const FileList = ({ files }) => {
  // console.log(files);
  if (isEmpty(files)) {
    return <div>No files yet</div>;
  }
  if (!Array.isArray(files)) {
    files = [files];
  }

  return (
    <List
      dataSource={files}
      renderItem={(item) => (
        <List.Item className="fileListItem">
          <FileListItem file={item} />
        </List.Item>
      )}
    />
  );
};

FileList.defaultProps = {
  files: [],
};

FileList.propTypes = {
  files: PropTypes.array.isRequired,
};

export default FileList;
